import { useQuery } from '@tanstack/react-query';
import { useConnection } from 'wagmi';

import { QueryKeys } from '@/app/shared/constants/queryKeys';
import { getPointsLeaderboard } from '@/app/shared/services/api';
import { PointsLeaderboardCurrentUser, PointsLeaderboardRow } from '@/app/shared/services/api/types';

export interface UsePointsLeaderboardReturn {
  rows: PointsLeaderboardRow[];
  user: PointsLeaderboardCurrentUser | null;
  totalUsers: number;
  totalPoints: string;
  updatedAt: string | null;
  isLoading: boolean;
  isUnavailable: boolean;
  refetch: () => void;
}

export const usePointsLeaderboard = (): UsePointsLeaderboardReturn => {
  const { address } = useConnection();

  const { data, isLoading, isFetched, refetch } = useQuery({
    queryKey: [QueryKeys.POINTS_LEADERBOARD, address],
    queryFn: () => getPointsLeaderboard({ address }),
  });

  return {
    rows: data?.rows ?? [],
    totalPoints: data?.totalPoints ?? '0',
    user: data?.user ?? null,
    totalUsers: data?.totalUsers ?? 0,
    updatedAt: data?.updatedAt ?? null,
    isLoading,
    isUnavailable: isFetched && data === null,
    refetch,
  };
};
